import type { TActivity, TSession } from "./activities"

const surveyTypes: TActivity["type"][] = ["survey", "pulse", "feedback", "onboarding"]

export const checkSurvey = ({ type }: { type?: TActivity["type"] } = {}) => type && surveyTypes.includes(type)

export function checkSessionFinished(props?: { state: TSession["state"]; dtfinish: number }) {
  if (!props) return false
  const { state, dtfinish } = props
  return state === "finished" || state === "canceled" || state === "declined" || dtfinish < Date.now()
}
